<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" :header="$t('订单信息')" class="goods-collapse">
              <a-form-model-item  :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" :label="$t('用户信息')" prop="userId" >
                <a-select :placeholder="$t('请选择')+$t('问题分类')" v-model="form.userId" allowClear>
                  <a-select-option v-for="(item) in userList" :value="item.id" :key="item.id" :title="item.name">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('选择商品')" prop="goodsList" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                <div @click="openProdSelect" style="width: 100px">
                  <a-button type="dashed" @click="openProdSelect" danger>
                    <span style="color: dodgerblue"> {{$t('选择商品')}}</span>
                  </a-button>
                </div>
              </a-form-model-item>
              <a-table v-if="this.form.goodsList.length>0" :loading="goodsLoading"
                       rowKey="id" :size="tableSize" :columns="goodsColumns" :data-source="form.goodsList" :pagination="false"
                       :bordered="tableBordered">
                <span slot="createTime" slot-scope="text, record">
                  {{ parseTime(record.createTime) }}
                </span>
                <template slot="picture" slot-scope="text, record">
                  <div>
                    <img v-if="record.picture" :src="record.picture" style="width:60px;height:62px;"
                         @click="handleRecordPreview(record.picture)" alt="none"/>
                  </div>
                </template>
                <template slot="skuId" slot-scope="text, record">
                  <a-select :placeholder="$t('请选择')+$t('名称')" v-model="record.skuId" allowClear>
                    <a-select-option v-for="item in skuList" :value="item.id" :key="item.id" :title="item.skuName">
                      {{ item.skuName }}
                    </a-select-option>
                  </a-select>
                </template>
                <div slot="payAmount" slot-scope="text, record">
                  <a-input-number :min="0.01" :max="100000000" :step="0.01" v-model="record.payPrice"   />
                </div>
                <div slot="goodsCount" slot-scope="text, record">
                  <a-input-number :min="1" :max="10000" v-model="record.goodsCount"   />
                </div>
                <span slot="operation" slot-scope="text, record">
                  <a @click="handleGoodsDelete(record.id)">
                    <a-icon type="delete"/>{{ $t('删除') }}
                  </a>
                </span>
              </a-table>
        </a-collapse-panel>
        <a-collapse-panel key="2" :header="$t('收货地址')" class="goods-collapse">
          <a-form-model-item :label="$t('FirstName')" prop="firstName">
            <a-input v-model="form.firstName" :maxLength="32" :placeholder="$t('请输入')+$t('First_name')" allow-clear />
          </a-form-model-item>
          <a-form-model-item :label="$t('LastName')" prop="lastName">
            <a-input v-model="form.lastName" :maxLength="32" :placeholder="$t('请输入')+$t('LastName')" allow-clear />
          </a-form-model-item>
          <a-form-model-item :label="$t('地区')" prop="areaxId">
            <a-cascader :options="areaList"
                        :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                        style="width: 100%" v-model="areaSelected" allowClear @change="onAreaChange">
            </a-cascader>
          </a-form-model-item>
          <a-form-model-item :label="$t('详细地址')" prop="detailedAddress">
            <a-input v-model="form.detailedAddress" :maxLength="32" :placeholder="$t('请输入')+$t('详细地址')" allow-clear />
          </a-form-model-item>
          <a-form-model-item :label="$t('邮编')" prop="postCode">
            <a-input v-model="form.postCode" :maxLength="32" :placeholder="$t('请输入')+$t('邮编')" allow-clear />
          </a-form-model-item>
        </a-collapse-panel>
        <a-collapse-panel  key="3" :header="$t('结算信息')" class="goods-collapse">
          <a-form-model-item :label="$t('商品金额')" prop="goodsAmount">
            <a-input v-model="form.goodsAmount" :maxLength="32" disabled allow-clear />
          </a-form-model-item>
          <a-form-model-item :label="$t('运费金额')" prop="shippingPayAmount">
            <a-input v-model="form.shippingPayAmount" :maxLength="32" disabled allow-clear />
          </a-form-model-item>
          <a-form-model-item :label="$t('税费')" prop="taxPayAmount">
            <a-input v-model="form.taxPayAmount" :maxLength="32" disabled allow-clear />
          </a-form-model-item>
          <a-form-model-item :label="$t('实付金额')" prop="totalPayAmount">
            <a-input v-model="form.totalPayAmount" :maxLength="32" disabled allow-clear />
          </a-form-model-item>
        </a-collapse-panel>
      </a-collapse>


      <!--      <a-form-model-item :label="$t('活动详情')" prop="description" >
              <editor v-model="form.description" :placeholder="$t('请输入')+$t('活动详情')"/>
            </a-form-model-item>-->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="preview">
            preview
          </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <radio-select-form ref="RadioSelectForm" @goodsSelect="indexGoodsModalSelect"></radio-select-form>
  </a-drawer>
</template>

<script>
import {getGoodsStock} from '@/api/goods/goods'
import { customPreview, customCreate} from '@/api/order/sell'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import Editor from "@/components/Editor/Editor";
import {translation} from "@/api/tool/common";
import RadioSelectForm from "@/views/goods/goods/modules/RadioSelectForm.vue";
import { tableMixin } from '@/store/table-mixin'
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import moment from 'moment';
import {cityArea, cityGlobal} from "@/api/logistics";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
    Editor,
    RadioSelectForm,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      moment,
      goodsLoading: false,
      goodsColumns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
        },
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: this.$t('规格'),
          dataIndex: 'skuId',
          scopedSlots: {customRender: 'skuId'},
        },
        {
          title: this.$t('定制单价'),
          dataIndex: 'payAmount',
          scopedSlots: {customRender: 'payAmount'}

        },
        {
          title: this.$t('数量'),
          dataIndex: 'goodsCount',
          scopedSlots: {customRender: 'goodsCount'}
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          scopedSlots: {customRender: 'operation'},
        }
      ],
      errorMessage:undefined,
      activeKey: [1, 2, 3, 4],
      activityTypeList:[],
      categoryList: [{id: "0", categoryName: ''}],
      cateOptions: [],
      brandList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      areaList: [],
      areaSelected: [],
      skuList: [],
      userList: [],
      // 表单参数
      form: {
        id: null,
        userId: null,
        goodsList: [],
        firstName: '',
        lastName: '',
        areaxId: undefined,
        detailedAddress: '',
        postCode: '',
        goodsAmount: 0,
        shippingPayAmount: 0,
        taxPayAmount: 0,
        totalPayAmount: 0
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: this.$t('用户信息') + this.$t('不能为空'), trigger: 'change' }
        ],
        firstName: [
          { required: true, message: this.$t('FirstName') + this.$t('不能为空'), trigger: 'blur' }
        ],
        goodsList: [
          { required: true, message: this.$t('goodsList') + this.$t('不能为空'), trigger: 'change' }
        ],
        lastName: [
          { required: true, message: this.$t('LastName') + this.$t('不能为空'), trigger: 'blur' }
        ],
        areaxId: [
          { required: true, message: this.$t('地区') + this.$t('不能为空'), trigger: 'change' }
        ],
        detailedAddress: [
          { required: true, message: this.$t('详细地址') + this.$t('不能为空'), trigger: 'blur' }
        ],
        postCode: [
          { required: true, message: this.$t('邮编') + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getAreaTree()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        goodsList: [],
        firstName: '',
        lastName: '',
        areaxId: undefined,
        detailedAddress: '',
        postCode: '',
        goodsAmount: 0,
        shippingPayAmount: 0,
        taxPayAmount: 0,
        totalPayAmount: 0
      }

    },
    getAreaTree() {
      cityArea({}).then(response => {
        this.areaList = response.data
      })
    },
    onAreaChange(value, selectedOptions) {
      this.form.areaxId = value[2]
    },
    handleGoodsDelete(key) {
      const dataSource = [...this.form.goodsList];
      this.form.goodsList = dataSource.filter(item => item.id !== key);
    },

    indexGoodsModalSelect(records) {
      //深拷贝
      this.form.goodsList = JSON.parse(JSON.stringify(records)).map(item => ({
        ...item,
        skuId: item.skuId || null
      }));
      console.log('商品选择了',this.form.goodsList)
      //查询商品的sku数据
      getGoodsStock({"id":this.form.goodsList[0].id}).then(response => {
        this.skuList = response.data.skuList
      })
    },
    openProdSelect() {
      this.$refs.RadioSelectForm.openGoods(null, null, null);
    },



    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      console.log('row,',row)
      this.userList = [{"id":row.userId+"", "name":row.name}];
      this.form.userId = row.userId;
      this.form.id = row.id;
      this.form.lastName = row.name;
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    preview: function () {
      if (this.form.goodsList.length === 0) {
        this.$message.error('Please Select Products', 3)
        return false;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          customPreview(this.form).then(response => {
            this.form.goodsAmount = response.data.goodsAmount;
            this.form.shippingPayAmount = response.data.shippingPayAmount;
            this.form.taxPayAmount = response.data.taxPayAmount;
            this.form.totalPayAmount = response.data.totalPayAmount;
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      });
    },
    handleJumpOrder(id) {
      this.$router.push({
        name: 'Sell',
        params:
            {
              id: id
            }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      if (this.form.goodsList.length === 0) {
        this.$message.error('Please Select Products', 3)
        return false;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message =  'create order success'
          customCreate(this.form).then(response => {
            this.$message.success(
                message,
                3
            )
            //跳转到订单详情
            this.handleJumpOrder(response.data.orderId)
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      });
    }
  }
}
</script>
<style  scoped>
.goods-collapse > .ant-collapse-header {
  color: #007ffd !important;
  background: #e8eef9;
}
</style>
